import SvgIcon from '@mui/material/SvgIcon';
import * as React from 'react';
const SvgCalendarTodayOutlined = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M9.454 5.75h5.092V4.344c0-.466.378-.844.848-.844s.849.378.849.844V5.75h1.414A2.257 2.257 0 0 1 19.92 8v11.25a2.26 2.26 0 0 1-2.263 2.25H6.343a2.257 2.257 0 0 1-2.263-2.25V8a2.256 2.256 0 0 1 2.263-2.25h1.414V4.344c0-.466.379-.844.849-.844s.848.378.848.844zm-3.677 13.5c0 .31.253.563.566.563h11.314a.566.566 0 0 0 .566-.563v-9H5.777z"
    }));
export default SvgCalendarTodayOutlined;
